/* Premier Catering Supplies — shared facet data (26-9-2026).
   Loads /collections/<handle>[/tags]?view=pcl-data (250 per page, all pages) and turns each product's
   specification text + title into clean facet values: diameter band, capacity band, material, colour(s), pack.
   Used by the collection filters (pcl-facets.js) and the homepage product finder (pch-finder.js). */
(function () {
  'use strict';
  if (window.PCLData) return;

  var DIA = [
    { k: 'd-0-119', label: 'Under 120mm', min: 1, max: 119 },
    { k: 'd-120-159', label: '120–159mm', min: 120, max: 159 },
    { k: 'd-160-209', label: '160–209mm', min: 160, max: 209 },
    { k: 'd-210-249', label: '210–249mm', min: 210, max: 249 },
    { k: 'd-250-289', label: '250–289mm', min: 250, max: 289 },
    { k: 'd-290-999', label: '290mm+', min: 290, max: 999 }
  ];
  var CAP = [
    { k: 'c-0-299', label: 'Up to 300ml', min: 1, max: 299 },
    { k: 'c-300-450', label: '300–450ml', min: 300, max: 450 },
    { k: 'c-451-999', label: '450ml–1 litre', min: 451, max: 999 },
    { k: 'c-1000-99999', label: 'Over 1 litre', min: 1000, max: 99999 }
  ];
  /* order = display order; first match wins */
  var MAT = [
    ['bone-china', 'Bone china', /bone\s*china/],
    ['fine-china', 'Fine china', /fine\s*china/],
    ['porcelain', 'Porcelain', /porcelain/],
    ['stoneware', 'Stoneware', /stoneware/],
    ['vitrified', 'Vitrified ceramic', /vitrified|alumina/],
    ['china', 'China', /\bchina\b/],
    ['earthenware', 'Earthenware', /earthenware|terracotta/],
    ['ceramic', 'Ceramic', /ceramic/],
    ['melamine', 'Melamine', /melamine/],
    ['glass', 'Glass', /glass|opal|crystal/],
    ['polycarbonate', 'Polycarbonate', /polycarbonate|tritan/],
    ['steel', 'Stainless steel', /stainless|steel/],
    ['wood', 'Wood & bamboo', /wood|bamboo|acacia/],
    ['slate', 'Slate', /slate/],
    ['plastic', 'Plastic', /plastic|polypropylene|\bpp\b|polystyrene/],
    ['paper', 'Paper & card', /paper|card|bagasse|kraft/],
    ['enamel', 'Enamel', /enamel/]
  ];
  var COL = [
    ['white', 'White', '#ffffff', /\b(white|ivory|snow|chalk)\b/],
    ['cream', 'Cream & beige', '#eadfc8', /\b(cream|beige|sand|sandstone|natural|barley|linen|taupe|latte|biscuit|mushroom|putty)\b/],
    ['grey', 'Grey', '#9aa0a8', /\b(grey|gray|ash|mist|smoke|pewter|charcoal|graphite|concrete)\b/],
    ['black', 'Black', '#1f2328', /\b(black|ebony|onyx|jet|midnight)\b/],
    ['blue', 'Blue', '#355c9a', /\b(blue|navy|ocean|indigo|denim|cobalt|aqua|azure|topaz)\b/],
    ['green', 'Green', '#5b7f55', /\b(green|moss|sage|olive|mint|jade|emerald|forest|lime|teal)\b/],
    ['brown', 'Brown', '#7a5230', /\b(brown|cinnamon|chocolate|coffee|bronze|rust|copper|walnut|mocha|caramel|tan)\b/],
    ['red', 'Red', '#b03a2e', /\b(red|burgundy|claret|wine|cherry|ruby|brick)\b/],
    ['pink', 'Pink', '#e2a0b0', /\b(pink|blush|rose|coral|salmon)\b/],
    ['orange', 'Orange', '#e07b2a', /\b(orange|amber|terracotta|peach|apricot)\b/],
    ['yellow', 'Yellow', '#e3c04b', /\b(yellow|mustard|lemon|saffron|ochre)\b/],
    ['purple', 'Purple', '#6b4a8a', /\b(purple|aubergine|plum|lilac|lavender|violet)\b/],
    ['gold', 'Gold', '#c8a45a', /\bgold(en)?\b/],
    ['silver', 'Silver', '#c9ccd1', /\b(silver|chrome|metallic)\b/],
    ['clear', 'Clear', 'transparent', /\b(clear|transparent)\b/]
  ];

  function lc(s) { return String(s || '').toLowerCase().replace(/&amp;/g, '&'); }
  function band(list, n) { if (!n) return ''; for (var i = 0; i < list.length; i++) if (n >= list[i].min && n <= list[i].max) return list[i].k; return ''; }
  function matOf(spec, title) {
    var s = lc(spec), t = lc(title), i;
    for (i = 0; i < MAT.length; i++) if (MAT[i][2].test(s)) return MAT[i][0];
    for (i = 0; i < MAT.length; i++) if (MAT[i][2].test(t)) return MAT[i][0];
    return '';
  }
  function colsOf(spec, title) {
    var s = lc(spec), out = [], i;
    for (i = 0; i < COL.length; i++) if (COL[i][3].test(s)) out.push(COL[i][0]);
    if (!out.length) {
      var t = lc(title);
      for (i = 0; i < COL.length; i++) if (COL[i][3].test(t)) out.push(COL[i][0]);
    }
    return out;
  }
  function diaOf(it) {
    if (it.d) return it.d;
    var m = lc(it.ft).match(/(\d{2,3})\s?mm\b/);
    return m ? +m[1] : 0;
  }
  function capOf(it) {
    if (it.c) return it.c;
    var t = lc(it.ft), m;
    if ((m = t.match(/(\d+(?:\.\d+)?)\s?ml\b/))) return Math.round(+m[1]);
    if ((m = t.match(/(\d+(?:\.\d+)?)\s?cl\b/))) return Math.round(+m[1] * 10);
    if ((m = t.match(/(\d+(?:\.\d+)?)\s?(?:ltr|litre|liter)s?\b/))) return Math.round(+m[1] * 1000);
    if ((m = t.match(/(\d+(?:\.\d+)?)\s?oz\b/))) return Math.round(+m[1] * 28.41);
    return 0;
  }
  function normalise(it) {
    var d = diaOf(it), c = capOf(it);
    it.f = {
      dia: band(DIA, d),
      cap: band(CAP, c),
      mat: matOf(it.m, it.ft),
      col: colsOf(it.co, it.ft),
      pack: String(it.k || 1)
    };
    it.dn = d; it.cn = c;
    return it;
  }

  var cache = {};
  /* url = collection path + current query (without view/page/section_id) */
  function load(url) {
    var key = url;
    if (cache[key]) return cache[key];
    var u = new URL(url, window.location.origin);
    ['view', 'page', 'section_id'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.set('view', 'pcl-data');
    function page(n) {
      u.searchParams.set('page', n);
      return fetch(u.pathname + '?' + u.searchParams.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    cache[key] = page(1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= Math.min(first.pages, 40); p++) rest.push(page(p));
      return Promise.all(rest).then(function (more) {
        var items = first.items;
        more.forEach(function (m) { items = items.concat(m.items); });
        items.forEach(normalise);
        return { total: first.total, items: items };
      });
    });
    cache[key].catch(function () { delete cache[key]; });
    return cache[key];
  }

  /* facet definitions: key, label, values(list of {k,label,sw?}) */
  function defs() {
    return [
      { key: 'dia', label: 'Diameter', type: 'chips', values: DIA.map(function (b) { return { k: b.k, label: b.label }; }) },
      { key: 'cap', label: 'Capacity', type: 'chips', values: CAP.map(function (b) { return { k: b.k, label: b.label }; }) },
      { key: 'mat', label: 'Material', type: 'checks', values: MAT.map(function (m) { return { k: m[0], label: m[1] }; }) },
      { key: 'col', label: 'Colour', type: 'swatches', values: COL.map(function (c) { return { k: c[0], label: c[1], sw: c[2] }; }) },
      { key: 'pack', label: 'Pack size', type: 'chips', values: null }
    ];
  }
  function has(it, key, val) { var v = it.f[key]; return Array.isArray(v) ? v.indexOf(val) > -1 : v === val; }
  /* state: {dia:[..], mat:[..]} — OR within a facet, AND across facets; skip = facet to ignore (for its own counts) */
  function match(it, state, skip) {
    for (var key in state) {
      if (key === skip || !state[key] || !state[key].length) continue;
      var ok = false;
      for (var i = 0; i < state[key].length; i++) if (has(it, key, state[key][i])) { ok = true; break; }
      if (!ok) return false;
    }
    return true;
  }
  function counts(items, state, key) {
    var out = {};
    items.forEach(function (it) {
      if (!match(it, state, key)) return;
      var v = it.f[key];
      (Array.isArray(v) ? v : [v]).forEach(function (x) { if (x) out[x] = (out[x] || 0) + 1; });
    });
    return out;
  }
  function packValues(items) {
    var seen = {};
    items.forEach(function (it) { seen[it.f.pack] = 1; });
    return Object.keys(seen).map(Number).sort(function (a, b) { return a - b; }).map(function (n) { return { k: String(n), label: n === 1 ? 'Single' : String(n) }; });
  }
  function parseHash(h) {
    var st = {};
    String(h || '').replace(/^#/, '').split('&').forEach(function (p) {
      var kv = p.split('=');
      if (!kv[0] || !kv[1]) return;
      if (['dia', 'cap', 'mat', 'col', 'pack'].indexOf(kv[0]) < 0 && kv[0] !== 'pg') return;
      st[kv[0]] = kv[0] === 'pg' ? +kv[1] || 1 : decodeURIComponent(kv[1]).split(',').filter(Boolean);
    });
    return st;
  }
  function toHash(st) {
    var parts = [];
    ['dia', 'cap', 'mat', 'col', 'pack'].forEach(function (k) { if (st[k] && st[k].length) parts.push(k + '=' + st[k].map(encodeURIComponent).join(',')); });
    if (st.pg && st.pg > 1) parts.push('pg=' + st.pg);
    return parts.length ? '#' + parts.join('&') : '';
  }

  window.PCLData = { load: load, defs: defs, match: match, counts: counts, packValues: packValues, parseHash: parseHash, toHash: toHash, DIA: DIA, CAP: CAP };
})();